import emoji from '/components/emoji';
import { fraunces } from '../Landing/fonts';
import FutureImage from '../FutureImage';

// Engraved single-ink artwork (public/img/badges/stamps/, generated with
// codex image gen). Rendered as an alpha mask filled with currentColor so
// the art prints in whatever ink the parent sets, light and dark mode
// alike. Country flags deliberately stay full-color twemoji.
const STAMP_ART = new Set([
  '1posts',
  '5posts',
  '10posts',
  '20posts',
  '50posts',
  '100posts',
  '1kviews',
  '10kviews',
  '100kviews',
  '1region',
  '3region',
  '5region',
  '8region',
  '12region',
  'hosting',
  'blogsbeta',
  'northern-america',
  'central-america',
  'caribbean',
  'south-america',
  'middle-east',
  'western-central-asia',
  'southern-asia',
  'south-eastern-asia',
  'eastern-asia',
  'africa',
  'oceania',
  'southern-europe',
  'western-europe',
  'eastern-europe',
  'northern-europe',
]);

const slugify = name => name.toLowerCase().replace(/[^a-z0-9]+/g, '-');

function InkArt({ slug }) {
  // Same-origin on purpose — the one exception to the image-proxy rule.
  // Browsers fetch mask-image CORS-anonymous (unlike <img>), and the truvvle
  // proxy sends no Access-Control-Allow-Origin, so a proxied mask is dropped
  // and the art renders invisible (the service worker surfaces the rejected
  // fetch as a 503). The PNGs are pre-optimized at commit time instead
  // (≤320px palette PNGs, see scripts/badge-stamps/).
  const url = `/img/badges/stamps/${slug}.png`;
  const mask = {
    maskImage: `url(${url})`,
    WebkitMaskImage: `url(${url})`,
    maskSize: 'contain',
    WebkitMaskSize: 'contain',
    maskPosition: 'center',
    WebkitMaskPosition: 'center',
    maskRepeat: 'no-repeat',
    WebkitMaskRepeat: 'no-repeat',
    backgroundColor: 'currentColor',
  };
  return <span className="tw-absolute tw-inset-0 tw-block" style={mask} />;
}

// The badge artwork, filling its (positioned) parent box: engraved ink art
// where we have it, account-birthday laurel with the year as live SVG text
// (year 16+ needs no new artwork), then twemoji, then the legacy PNG.
export default function BadgeArt({ badge, type }) {
  const yearMatch =
    type === 'activity' ? /^(\d+)years$/.exec(badge.name) : null;
  const slug = yearMatch ? 'laurel' : slugify(badge.name);

  if (yearMatch || STAMP_ART.has(slug)) {
    return (
      <>
        <InkArt slug={slug} />
        {yearMatch && (
          <svg
            viewBox="0 0 100 100"
            className="tw-absolute tw-inset-0 tw-h-full tw-w-full"
          >
            <text
              x="50"
              y="52"
              textAnchor="middle"
              dominantBaseline="central"
              fontSize="34"
              fontWeight="600"
              fill="currentColor"
              fontFamily={fraunces.style.fontFamily}
            >
              {yearMatch[1]}
            </text>
          </svg>
        )}
      </>
    );
  }

  return (
    <span className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center [&_img]:tw-h-full [&_img]:tw-w-full [&_img]:tw-object-contain">
      {badge.emoji ? (
        emoji(badge.emoji)
      ) : (
        <FutureImage
          src={`/img/badges/${badge.name}.png`}
          alt=""
          width={96}
          height={96}
        />
      )}
    </span>
  );
}
